import { render, staticRenderFns } from "./FormUploadImage.vue?vue&type=template&id=0f0fab45&scoped=true&lang=pug&"
import script from "./FormUploadImage.vue?vue&type=script&lang=js&"
export * from "./FormUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./FormUploadImage.vue?vue&type=style&index=0&id=0f0fab45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0fab45",
  null
  
)

export default component.exports